module.exports = __webpack_public_path__ + "img/DJ.273f5090.svg";